import {
	MarketingPage,
	MarketingSection,
} from './+shared/marketing-page.tsx'
import { type Route } from './+types/tos.ts'

export const meta: Route.MetaFunction = () => [
	{ title: 'Algemene voorwaarden — Muziekdocent' },
	{
		name: 'description',
		content:
			'De algemene voorwaarden van Muziekdocent: licenties per leerling, gratis docentaccounts, opzeggen wanneer je wilt.',
	},
]

export default function TermsOfServiceRoute() {
	return (
		<MarketingPage
			title="Algemene voorwaarden"
			intro="In gewone taal: jij geeft les, wij zorgen dat het platform werkt. Versie 1.0 — juli 2026."
		>
			<MarketingSection title="1. De dienst">
				<p>
					Muziekdocent is een browsergebaseerd muziekeducatieplatform voor
					het voortgezet onderwijs (drumpad, piano, studio, opdrachten en
					leerlingvolgsysteem), geleverd door Muziekdocent AI B.V. te
					Amsterdam.
				</p>
			</MarketingSection>

			<MarketingSection title="2. Licenties en betaling">
				<p>
					Docentaccounts zijn altijd gratis. Scholen betalen per actieve
					leerling per schooljaar volgens de actuele prijzen op de website,
					met een maximum per school. De proefperiode van 30 dagen is
					volledig vrijblijvend en vraagt geen betaalgegevens.
				</p>
			</MarketingSection>

			<MarketingSection title="3. Opzeggen">
				<p>
					Een schoollicentie loopt per schooljaar en is maandelijks
					opzegbaar tijdens de proefperiode. Na opzegging kunnen scholen
					hun gegevens exporteren; 90 dagen na deactivering verwijderen we
					alles definitief.
				</p>
			</MarketingSection>

			<MarketingSection title="4. Gebruik">
				<p>
					Accounts zijn persoonlijk. Scholen zorgen ervoor dat het gebruik
					door leerlingen past binnen hun eigen ICT- en gedragsregels. Het
					is niet toegestaan het platform te gebruiken voor doeleinden
					buiten muziekonderwijs of om de beveiliging te omzeilen.
				</p>
			</MarketingSection>

			<MarketingSection title="5. Beschikbaarheid en aansprakelijkheid">
				<p>
					We streven naar maximale beschikbaarheid maar garanderen geen
					ononderbroken werking. Aansprakelijkheid is beperkt tot het
					bedrag dat de school in het lopende schooljaar voor de licentie
					heeft betaald.
				</p>
			</MarketingSection>

			<MarketingSection title="6. Privacy">
				<p>
					Op alle verwerking van persoonsgegevens is onze{' '}
					<a
						href="/privacyverklaring"
						className="text-white underline underline-offset-4"
					>
						privacyverklaring
					</a>{' '}
					en de verwerkersovereenkomst van toepassing.
				</p>
			</MarketingSection>

			<MarketingSection title="7. Toepasselijk recht">
				<p>
					Op deze voorwaarden is Nederlands recht van toepassing. Vragen?{' '}
					<a
						href="mailto:info@muziekdocent.nl"
						className="text-white underline underline-offset-4"
					>
						info@muziekdocent.nl
					</a>
					.
				</p>
			</MarketingSection>
		</MarketingPage>
	)
}
